export const lightPalette = {
  primary: {
    light: '#4397dc',
    main: '#1e8bc3',
    dark: '#126b98',
    contrastText: '#fff',
    hover: 'rgba(25, 118, 210, 0.08)',
    border: 'rgba(25, 118, 210, 0.12)',
  },
  secondary: {
    light: '#fbed56',
    main: '#f9f347',
    dark: '#e0c62f',
    contrastText: '#000',
  },
  background: {
    default: '#fafbfc', // Softer off-white background (less harsh than pure white)
    paper: '#ffffff', // White for cards/modals
    game: '#f8f9fa', // Light gray for game areas
    sidebar: '#f5f5f5', // Subtle gray for sidebars,
    home: '#ffffff',
  },
  surface: {
    primary: '#ffffff',
    secondary: '#f8f9fa',
    tertiary: '#e9ecef',
    home: '#F2F3FE',
  },
  text: {
    white: '#ffffff',
    black: '#000000',
    primary: '#212529',
    secondary: '#6c757d',
    disabled: '#adb5bd',
  },
  border: {
    light: '#e0e0e0',
    main: '#d0d0d0',
    dark: '#b0b0b0',
  },
  error: {
    main: '#dc3545',
    light: '#f8d7da',
    dark: '#721c24',
  },
  warning: {
    main: '#fd7e14',
    light: '#fff3cd',
    dark: '#843c0c',
  },
  success: {
    main: '#198754',
    light: '#d1e7dd',
    dark: '#0f5132',
  },
  info: {
    main: '#0dcaf0',
    light: '#cff4fc',
    dark: '#055160',
  },
  action: {
    hover: 'rgba(0, 0, 0, 0.2)',
    hoverLight: 'rgba(0, 0, 0, 0.04)',
  },
  // Custom PlayFactile colors
  factileWhite: {
    light: '#f9f9f9',
    main: '#f5f5f5',
    dark: '#f2f2f2',
  },
  factilePink: {
    main: '#ff58a3',
    light: '#ff85c3',
    dark: '#d63384',
  },
  factileYellow: {
    main: '#f9f347',
    light: '#fbed56',
    dark: '#e0c62f',
  },
  factileGreen: {
    main: '#20c997',
    light: '#75dab4',
    dark: '#0f6848',
  },
  home: {
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#454343',
    searchBackground: '#F2F3FE',
    gameModesBackground: '#EAEBFD',
  },
  plans: {
    background: '#ffffff',
    text: '#000000',
    textSecondary: '#414141',
    textMuted: '#666666',
    border: '#e6e6e6',
    tableBackground: '#f8f7f7',
    cardFree: '#fdfdfd',
    cardBasic: '#c3e4f4',
    cardPlus: '#c8f8db',
    cardBusiness: '#ecbb9b',
    badgeBackground: 'rgba(230, 230, 230, 0.5)',
  },
};

// Dark theme palette - based on EditPage.jsx color scheme
export const darkPalette = {
  primary: {
    light: '#4397dc', // Lighter blue for hover states
    main: '#1e8bc3', // Main blue color from EditPage
    dark: '#004f71', // Dark blue for main background
    contrastText: '#fff',
    hover: 'rgba(18, 107, 152, 0.6)', // Specific hover color from EditPage
    border: 'rgba(18, 107, 152, 0.12)',
  },
  secondary: {
    light: '#f9ec57', // Light yellow
    main: '#f9f347', // Main yellow from EditPage borders/outlines
    dark: '#ffd747', // Dark yellow for hover states
    contrastText: '#000',
  },
  background: {
    default: '#032d43', // Very dark blue background from EditPage preview
    paper: '#093552', // Toolbar background color from EditPage
    game: '#004f71', // Primary dark background
    sidebar: '#0a4a68', // Slightly lighter than paper for sidebars
    home: '#000000',
  },
  surface: {
    primary: '#093552', // Main toolbar/surface color
    secondary: '#126b98', // Lighter surface color
    tertiary: '#1e8bc3', // Lightest surface color
  },
  text: {
    primary: '#ffffff', // White text (main text in EditPage)
    secondary: '#adb5bd', // Light gray for secondary text
    disabled: '#6c757d', // Disabled text
    main: '#fff', // Legacy support - main text color
    light: '#363636', // Legacy support
    grey: '#292929', // Legacy support
    dark: '#000000', // Legacy support
  },
  border: {
    light: '#ffffff', // White borders from EditPage
    main: '#f9f347', // Yellow borders (secondary.main)
    dark: '#e0c62f', // Darker yellow borders
  },
  action: {
    hover: 'rgba(18, 107, 152, 0.6)',
    hoverLight: 'rgba(18, 107, 152, 0.1)',
  },
  error: {
    main: '#ff6b6b',
    light: '#ff8e8e',
    dark: '#dc3545',
  },
  warning: {
    main: '#ffd43b',
    light: '#ffdd57',
    dark: '#fd7e14',
  },
  success: {
    main: '#51cf66',
    light: '#69db7c',
    dark: '#37b24d',
  },
  info: {
    main: '#339af0',
    light: '#4dabf7',
    dark: '#1c7ed6',
  },
  // Custom PlayFactile colors matching EditPage usage
  factilePink: {
    main: '#ff58a3', // Pink accent from EditPage
    light: '#ff85c3',
    dark: '#fc66ca', // Darker pink from EditPage
  },
  factileYellow: {
    main: '#f9f347', // Same as secondary.main
    light: '#fbed56',
    dark: '#e0c62f',
  },
  factileWhite: {
    light: '#f9f9f9', // Legacy support
    main: '#f5f5f5', // Legacy support
    dark: '#f2f2f2', // Legacy support
  },
  factileGrey: {
    light: '#363636', // Legacy support
    main: '#6c757d', // Legacy support
    dark: '#292929', // Legacy support
  },
  factileGreen: {
    main: '#40e0d0',
    light: '#5ee6d3',
    dark: '#20c997',
  },
  plans: {
    background: '#032d43',
    text: '#ffffff',
    textSecondary: '#adb5bd',
    textMuted: '#6c757d',
    border: '#126b98',
    tableBackground: '#093552',
    cardFree: '#004f71',
    cardBasic: '#1e8bc3',
    cardPlus: '#20c997',
    cardBusiness: '#fd7e14',
    badgeBackground: 'rgba(18, 107, 152, 0.3)',
  },
};
